// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBx6Ci6LCangdbl9gwydpbZmrVQKT4yp3Y",
  authDomain: "quotabus-landing-pages.firebaseapp.com",
  projectId: "quotabus-landing-pages",
  storageBucket: "quotabus-landing-pages.firebasestorage.app",
  messagingSenderId: "971555561460",
  appId: "1:971555561460:web:e55f74281227572ef8a3a1",
  measurementId: "G-WF5C8J7R8Z",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const FirebaseAnalytics = () => {
  const location = useLocation();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (analytics) {
      const page_path = location.pathname + location.search;
      // Extract bus partner code from the first path segment
      const busPartnerCode = process.env.REACT_APP_PARTNER_CODE;
      logEvent(analytics, "page_view", {
        page_path: "lp-" + busPartnerCode + page_path,
        bus_partner: busPartnerCode,
        user_lang: i18n.language,
      });
    }
  }, [location, i18n.language]);

  return null;
};
